import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import DesktopBanner from '../assets/contact/desktop-contact-banner.jpg';
import MobileBanner from '../assets/contact/mobile-contact-banner.jpg';
import ContactForm from '../components/Common/contact-form';

const Contact = () => {
useEffect(() => {AOS.init({duration: 1000, easing: "ease-in-out", once: true,});}, []);
return (
<div>
  {/* Mobile Banner */}
  <div className='w-full' data-aos="fade-down">
  <img className="md:hidden w-full" src={MobileBanner} alt="Mobile Contact Banner"/></div>

  {/* Desktop Banner */}
  <div className='w-full' data-aos="fade-down">
  <img className="hidden md:flex w-full" src={DesktopBanner} alt="Desktop Contact Banner"/></div>

  {/* Contact Heading */}
  <div className='w-full px-8 pt-8 md:px-32 md:pt-10 text-blue font-tenor' data-aos="fade-up">
  <p className='text-2xl md:text-3xl uppercase mb-2 font-bold'>Contact Us</p>
  <p className='text-sm md:text-base'>We are here to answer your questions and provide more information about our schools and initiatives.</p></div>
  <div className='md:mt-4 mb-8 md:mb-10 md:px-32 px-8'><ContactForm/></div>
  
 </div>);};

export default Contact;